import {OverlayScrollbars} from "overlayscrollbars"

/**
 * If you need do something with the flatpickr instance, you can use the following interface \n
 * @example import {OverlayScrollbars} from "js/overlayscrollbars/overlayscrollbars"
 *
 * const overlayscrollbar = document.querySelector<OverlayScrollbars>(".your-overlayscrollbar")
 *
 * overlayscrollbar.scrollbars
 */
export interface OverlayscrollbarsElement extends HTMLElement {
  scrollbars?: OverlayScrollbars
}

const init = () => {
  const scrollbarElements = document.querySelectorAll<OverlayscrollbarsElement>(".u-scrollbar:not(.--initialized)")

  scrollbarElements.forEach((scrollbarElement) => {
    const x = scrollbarElement.hasAttribute("data-scrollbar-x")
    const y = scrollbarElement.hasAttribute("data-scrollbar-y")

    const overlayScrollbarsInstance = OverlayScrollbars(scrollbarElement, {
      overflow: {
        x: x ? "scroll" : "hidden",
        y: y ? "scroll" : "hidden",
      },
    })

    scrollbarElement.scrollbars = overlayScrollbarsInstance

    scrollbarElement.classList.add("--initialized")
  })
}
init()
document.addEventListener("overlayscrollbarsReinit", init)
